<template>
  <div
    class="bg-header-blue"
    v-show="this.$store.state.layout === 'default'"
    :class="getClassName()"
    v-bind="$attrs"
  >
  </div>
  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-sm"
    :class="`${
      this.$store.state.isRTL
        ? 'me-3 rotate-caret fixed-end'
        : 'fixed-start ms-3'
    } 
    ${
      this.$store.state.layout === 'landing'
        ? 'bg-transparent shadow-none'
        : ' '
    } ${this.$store.state.sidebarType}`"
    id="sidenav-main"
  >
    <div class="sidenav-header" style="z-index: 99;">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <router-link class="m-0 navbar-brand" to="/dashboard">
        <img
          src="@/assets/img/Logo-KPI-BSB-Final.png"
          class="navbar-brand-img w-100"
          alt="main_logo"
        />
      </router-link>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :cardBg="custom_class" />
    <div class="pt-3 mx-3 mt-3 sidenav-footer" style="position: sticky;bottom: 0;background: #fff;">
      <sidenav-card
        textPrimary="Need Help?"
        textSecondary="Please check our docs"
      />
    </div>
  </aside>
</template>

<style scoped>
.sidenav-header {
  position: sticky;
  top: 0;
  background: #fff;
  height: 11.5rem;
}
.navbar-vertical.navbar-expand-xs {
  z-index: unset!important;
}
</style>

<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logo-ct-dark.png";
import logoWhite from "@/assets/img/logo-ct.png";
import SidenavCard from "./SidenavCard.vue";

export default {
  name: "index",
  components: {
    SidenavList,
    SidenavCard
  },
  data() {
    return {
      logo,
      logoWhite
    };
  },
  methods: {
    getClassName() {
      if (this.className) {
        return Object.keys(this.className).map((item) => {
          return this.className[item]
        }).join(" ");
      }
      return "";
    }
  },
  props: {
    custom_class: {
      type: String,
      required: false,
    },
    layout:  {
      type: String,
      required: false,
    },
    className: {
      type: Object,
      default: () => {return {}},
    }
  }
};
</script>
